/* eslint-disable ember/no-computed-properties-in-native-classes */
import CommonNewPost from '@linc-technologies/linced-common/components/new-post';
import { isArray } from '@ember/array';
import { computed } from '@ember/object';

export default class NewPost extends CommonNewPost {
  schoolId = null;
  heroPremierEnabled = true;
  schoolGroups = null;

  // NOTE: heroDuoEnabled and userCanTag must stay getters. Both are computed
  // properties on the linced-common NewPost we extend, and heroDuoEnabled is an
  // `alias`, so a class field would not shadow it - it would write straight
  // through to `computedSchool.heroDuoEnabled` at construction time.
  get heroDuoEnabled() {
    return true;
  }

  get userCanTag() {
    return false;
  }

  @computed('schoolGroups.[]')
  get filteredGroups() {
    if (isArray(this.schoolGroups)) {
      return this.schoolGroups
        .slice()
        .sort(
          (a, b) =>
            (a.grouping || '').localeCompare(b.grouping || '') ||
            (a.name || '').localeCompare(b.name || ''),
        );
    }
    return [];
  }
}
